import Swiper from 'swiper/swiper-bundle';
if (jQuery('.full-slider').length) {
  var swiper = new Swiper(".full-slider .swiper", {
    loop: true,
    navigation: {
      nextEl: ".full-slider .swiper-button-next",
      prevEl: ".full-slider .swiper-button-prev"
    }
  });
}
if (jQuery('.speaker__slider').length) {
  var _swiper = new Swiper(".speaker__slider", {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
      delay: 3000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false
    },
    navigation: {
      nextEl: ".speaker .swiper-button-next",
      prevEl: ".speaker .swiper-button-prev"
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0
      },
      480: {
        slidesPerView: 2,
        slidesPerGroup: 1,
        spaceBetween: 0
      },
      560: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 0
      },
      768: {
        slidesPerView: 4,
        slidesPerGroup: 1,
        spaceBetween: 0
      },
      1024: {
        slidesPerView: 4,
        slidesPerGroup: 1,
        spaceBetween: 0
      },
      1200: {
        slidesPerView: 6,
        slidesPerGroup: 1,
        spaceBetween: 0
      },
      1600: {
        slidesPerView: 8,
        slidesPerGroup: 1,
        spaceBetween: 0
      }
    }
  });
}
if (jQuery('.testimonials__slider').length) {
  var _swiper2 = new Swiper(".testimonials__slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false
    },
    navigation: {
      nextEl: ".testimonials .swiper-button-next",
      prevEl: ".testimonials .swiper-button-prev"
    }
  });
}
if (jQuery('.logo-slider').length) {
  var _swiper3 = new Swiper(".logo-slider__container", {
    slidesPerView: 1,
    slidesPerGroup: 1,
    rewind: true,
    grid: {
      fill: 'row',
      rows: 4
    },
    autoplay: {
      delay: 3000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false
    },
    navigation: {
      nextEl: ".logo-slider .swiper-button-next",
      prevEl: ".logo-slider .swiper-button-prev"
    },
    breakpoints: {
      480: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        grid: {
          fill: 'row',
          rows: 4
        }
      },
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        grid: {
          fill: 'row',
          rows: 4
        }
      },
      1600: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        grid: {
          fill: 'row',
          rows: 4
        }
      },
      1760: {
        slidesPerView: 5,
        slidesPerGroup: 5,
        grid: {
          fill: 'row',
          rows: 4
        }
      }
    }
  });
}